/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestCommentDto } from '../../models/contents-request-comment-dto';

export interface ContentsRequestCommentControllerFindAll$Params {
}

export function contentsRequestCommentControllerFindAll(http: HttpClient, rootUrl: string, params?: ContentsRequestCommentControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentsRequestCommentDto>>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestCommentControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContentsRequestCommentDto>>;
    })
  );
}

contentsRequestCommentControllerFindAll.PATH = '/api/contents-request-comment';
